import { isEmpty } from 'lodash';

const getHelpRequestOperatorStatusResponse = (data) => {
  if (isEmpty(data?.helpRequests)) return { isOpen: false };

  return {
    isOpen: true,
    helpRequest: data.helpRequests[0],
  };
};

export default getHelpRequestOperatorStatusResponse;
